<script setup lang="ts">
import { computed } from "vue";
import { styleZoom } from "@/common/utils/style";

const emit = defineEmits(["block:update"]);

const props = defineProps<{
  block: any;
  selectedBlock: string | null;
  zoom: number;
}>();

const columns = computed(() =>
  props.block.content?.columns?.filter((col: any) => !!col.visible)
);

const rows = computed(() =>
  props.block.content?.rows
    ?.filter((row: any) => !!row.visible)
    ?.filter((row: any) =>
      row.items.some((item: any) => {
        const col = columns.value.find((c: any) => c.id === item.col);
        return col && col.visible;
      })
    )
);
</script>

<template>
  <div
    class="table-block"
    :class="{
      selected: !!selectedBlock,
    }"
    :style="styleZoom(block.style, zoom)"
  >
    <template v-if="block.content?.title">
      <div class="table-title">
        {{ block.content?.title }}
      </div>
    </template>
    <table class="data-table">
      <thead>
        <tr>
          <template v-for="col in columns" :key="col.id">
            <th>
              {{ col.label }}
            </th>
          </template>
        </tr>
      </thead>

      <tbody>
        <template v-for="row in rows" :key="row.id">
          <tr>
            <template v-for="item in row.items" :key="item.id">
              <td>{{ item.value }}</td>
            </template>
          </tr>
        </template>
      </tbody>
    </table>
  </div>
</template>

<style lang="scss" scoped>
.table-block {
  overflow-x: auto;

  .table-title {
    padding-inline: 0.875em;
    padding-block: 0.3em;
    font-size: 1em;
    font-weight: bold;
    background: #f8f9fa;
    border: 1px solid #dee2e6;
    border-bottom: 0;
  }

  .data-table {
    width: 100%;
    border-collapse: collapse;
    border: 1px solid #dee2e6;

    th,
    td {
      border: 1px solid #dee2e6;
      padding-inline: 0.875em;
      padding-block: 0.5em;
    }

    th {
      background: #f8f9fa;
      font-weight: bold;
      font-size: 0.875em;
      text-align: center;
    }

    td {
      background: #fff;
      font-weight: normal;
      font-size: 0.875em;
      text-align: center;
    }
  }
}
</style>
